import { AxiosPromise } from 'axios';

import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

interface ExportOfferRequest {
    offerId: string;
    skipMariAppsVesselValidation?: boolean;
}

export const exportOffer = async ({
    offerId,
    skipMariAppsVesselValidation = false,
}: ExportOfferRequest): AxiosPromise<void> => {
    const params = new URLSearchParams({
        offerId,
        skipMariAppsVesselValidation: String(skipMariAppsVesselValidation),
    });

    return authorizedAxiosInstance.post(`/v1/maersk/purchase-order/export?${params}`);
};

export const confirmOffer = async (offerId: string, customerId: String): AxiosPromise<void> => {
    return authorizedAxiosInstance.post(
        `/v1/maersk/purchase-order/confirm?offerId=${offerId}&customerId=${customerId}`
    );
};

export const importPurchaseRequest = async (code: string, changesFrom: Date): AxiosPromise<void> => {
    return authorizedAxiosInstance.post(
        `/v1/maersk/purchase-requests/import?glsmCodes=${code}&changesFrom=${changesFrom.toISOString()}`
    );
};
